<template>
    <svg
        @click="emit('click')"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        viewBox="0 0 24 24"
        class="transition-all duration-300 cursor-pointer w-10 h-10"
        :class="[
            active
                ? `text-${color} hover:scale-110`
                : 'text-black/30 hover:text-black/50 hover:scale-105',
        ]"
    >
        <path
            v-if="active"
            stroke-linecap="round"
            stroke-linejoin="round"
            :d="asc ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'"
        />
        <path
            v-else
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 12h12"
        />
    </svg>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
    (e: "click"): void;
}>();

defineProps<{
    asc: boolean;
    active: boolean;
    color: "accent" | "secondary";
}>();
</script>
